//////////////////
// IMPORTS
//////////////////
// libraries
// import * as ISchema from "@schema";
import * as React from "react";
import { createFragmentContainer } from "react-relay";
import { connect } from "react-redux";

// components
import { AutopilotFlexibility } from "@components/autopilot-flexibility";

// util
import { IReduxState } from "@reducers/root.reducer";
import { EFlex } from "@util/event-tag.util";
import { setPricingDialogOpen } from "@actions/payments.actions";
import { track, TrackingEvents } from "@clockwise/web-commons/src/util/analytics.util";

// AutopilotForm imports
import { IProps, IContainer } from "./AutopilotFormSidebarScheduler.d";
import { autopilotFormFragments } from "./AutopilotForm.gql";
import { DayOffsetTimeSlot } from "@clockwise/client-commons/src/util/time-slot";
import { FlexibilityLearnMore } from "@clockwise/web-commons/src/ui/autopilot-flexibility/flexibility-learn-more";

interface IState {
  showSettings: boolean;
}

//////////////////
// COMPONENT
//////////////////
export class AutopilotFormSidebarSchedulerComponent extends React.Component<IProps, IState> {
  public static defaultProps = {
    org: null,
  };

  private defaultFlex = EFlex.Day;

  private isToggledOn = () => {
    const { flex } = this.props.formState;
    return flex === EFlex.Day || flex === EFlex.Week;
  };

  private onToggle = () => {
    // important!!
    // if currently on, toggling turns autopilot off, which pins it
    const flex = this.isToggledOn() ? EFlex.Pin : this.defaultFlex;
    this.props.onChange({
      ...this.props.formState,
      flex,
    });
  };

  private onClickView = () => {
    this.props.setPricingDialogOpen(true);
    track(TrackingEvents.PAYWALLS.MOVE_RANGES_CLICK_VIEW_PLANS);
  };

  private isPlanRestricted = () => {
    const { moveRangesEnabledFromFeatureGrid } = this.props;
    const restricted = !moveRangesEnabledFromFeatureGrid;

    return !!restricted;
  };

  private onChangeFlex = (flex: EFlex) => {
    this.props.onChange({
      ...this.props.formState,
      flex,
    });
  };

  private onChangeRoom = () => {
    this.props.onChange({
      ...this.props.formState,
      allowSimilarRooms: !this.props.formState.allowSimilarRooms,
    });
  };

  private onChangeTime = (
    allowedStart: DayOffsetTimeSlot | null,
    allowedEnd: DayOffsetTimeSlot | null,
  ) => {
    this.props.onChange({
      ...this.props.formState,
      timeRange: {
        allowedStart,
        allowedEnd,
      },
    });
  };

  private isOrgOverLimit = () => {
    const { org, autopilotPausedFromFeatureGrid } = this.props;

    if (!org) {
      return false;
    }

    return autopilotPausedFromFeatureGrid;
  };

  private onFlexibilityFaqSelect = () => {
    track(TrackingEvents.HELP.WHAT_MEETINGS_SHOULD_MARK_FLEX);
  };

  public render() {
    const { showRoom, formState, isDisabled, warning, org, selectedDate } = this.props;
    const disabledForm = !!isDisabled || warning;
    const disabledOptions = disabledForm || !this.isToggledOn();
    const currentFlex = formState.flex !== EFlex.Pin ? formState.flex : this.defaultFlex;

    return (
      <div style={{ marginTop: 5, paddingLeft: 4, paddingRight: 8 }}>
        <AutopilotFlexibility
          event={null}
          org={org ?? null}
          onChangeFlex={this.onChangeFlex}
          onChangeRoom={this.onChangeRoom}
          onChangeTime={this.onChangeTime}
          selectedFlex={currentFlex}
          allowSimilarRooms={!!formState.allowSimilarRooms}
          disabled={disabledOptions}
          showRoom={showRoom}
          selectedDate={selectedDate}
          isAutopilotEnabled={currentFlex !== EFlex.Pin}
          planRestricted={this.isPlanRestricted()}
          onClickView={this.onClickView}
          allowedStart={formState.timeRange?.allowedStart}
          allowedEnd={formState.timeRange?.allowedEnd}
          schedulingNewEvent
          attendeeMeetingHoursIntersect={true}
          onToggle={this.onToggle}
          warning={warning}
          fixed={this.isOrgOverLimit()}
          isExtension={false}
        />
        <div style={{ marginTop: 8 }}>
          <FlexibilityLearnMore onFlexibilityFaqSelect={this.onFlexibilityFaqSelect} />
        </div>
      </div>
    );
  }
}

//////////////////
// REDUX
//////////////////
function mapStateToProps(state: IReduxState, _ownProps: IContainer) {
  return {
    autopilotPausedFromFeatureGrid: state.featureGrid.mixedFreemiumOrgUIState.autopilotPaused,
    moveRangesEnabledFromFeatureGrid: state.featureGrid.mixedFreemiumOrgUIState.moveRangesEnabled,
  };
}

const reduxContainer = connect(mapStateToProps, {
  setPricingDialogOpen,
})(AutopilotFormSidebarSchedulerComponent);

///////////
// Relay //
///////////

export const AutopilotFormSidebarScheduler = createFragmentContainer(
  reduxContainer,
  autopilotFormFragments,
);
